import CryptoJS from 'crypto-js';
import EnvConfig from 'env.config';
import { ApiService } from 'services';
import { getStorageKey } from '../storage/getStorageSetting';

export const UPDATE_SELECTED_CLIENT = 'UPDATE_SELECTED_CLIENT';

// ok, so a number of things are going on here:
// the permisssions object in *redux* is set in a separate permissions variable, ignoring settings.permissions
// on a page refresh, the permissions are taken from settings.permissions in *sessionStorage*
// you need both of these (settings.permissions in sessionStorage and permissions in redux) to be set for full functionality
// that's why getActivityPermissions() does both
// the api call is async, hence the async/await below
function updateSelectedClient(jsonObject, permissions) {
  return {
    type: UPDATE_SELECTED_CLIENT,
    settings: jsonObject,
    permissions
  };
}

function decryptSettings() {
  const key = getStorageKey();
  if (!key) {
    return null;
  }
  const options = sessionStorage.getItem(EnvConfig.optionsName);
  if (!options) {
    return null;
  }
  return JSON.parse(CryptoJS.AES.decrypt(options, key.substring(64, 96)).toString(CryptoJS.enc.Utf8));
}

function encryptSettings(jsonObject) {
  const key = getStorageKey();
  if (!key) {
    return null;
  }
  return CryptoJS.AES.encrypt(JSON.stringify(jsonObject), key.substring(64, 96));
}

function getActivityPermissions() {
  const jsonObject = decryptSettings();

  return ApiService.getActivityPermissions().then((response) => {
    if (response != null && response.data != null && response.data !== '') {
      jsonObject.permissions = response.data;
      const encryptedData = encryptSettings(jsonObject);
      sessionStorage.setItem(EnvConfig.optionsName, encryptedData);
      return jsonObject;
    }
    return jsonObject;
  });
}

export function proceedWithClient(client) {
  let jsonObject = decryptSettings();
  jsonObject.selectedClient = client;
  const encryptedData = encryptSettings(jsonObject);
  sessionStorage.setItem(EnvConfig.optionsName, encryptedData);

  return async (dispatch) => {
    jsonObject = await getActivityPermissions();
    await ApiService.switchClientRefreshToken();
    dispatch(updateSelectedClient(jsonObject, jsonObject.permissions));
  };
}

export function clearSelectedClient() {
  const jsonObject = decryptSettings();
  jsonObject.selectedClient = null;
  const encryptedData = encryptSettings(jsonObject);
  sessionStorage.setItem(EnvConfig.optionsName, encryptedData);

  return async (dispatch) => {
    dispatch(updateSelectedClient(jsonObject, null));
  };
}
